var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("textarea", {
    staticClass: "ckeditor-vue",
    attrs: { id: _vm.id, "data-config": _vm.config },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }